<template>
    <div class="banner">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in publicData.Banner" :key="index">
          <img v-lazy="image" />
        </van-swipe-item>
      </van-swipe>
    </div>
</template>

<script>
    export default {
        name: '',
        props:['publicData'],
        data () {
            return {
              images: [
                require("../../assets/icon_carType01.jpg"),
                require("../../assets/icon_carType02.jpg"),
                require("../../assets/icon_carType03.jpg"),
                require("../../assets/icon_carType04.jpg")
              ]
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {
        overflow: hidden;
    }

    .clearfix:before, .clearfix:after {
        clear: both;
        content: " ";
        display: table;
    }
    .banner{height: 312px;}
    .van-swipe{width: 100%;height: 100%}
    .van-swipe-item img{width: 100%;height: 100%}
    .van-swipe__indicator{width: 16px;height: 16px;background: #4d667e;opacity: 1}
</style>



// WEBPACK FOOTER //
// src/components/Banner/Banner.vue